import { useOktaAuth } from '@okta/okta-react';

/**
 * Wraps `useOktaAuth` and exposes a stable `isAuthResolved` flag. On a full
 * page reload Okta restores the session asynchronously — during that window
 * `authState` is either null or has `isPending: true`, and reading
 * `isAuthenticated` would race (false for a moment, then true). Wait until
 * `isAuthResolved` is true before making auth decisions.
 */
export function useOktaAuthReady() {
  const { oktaAuth, authState } = useOktaAuth();

  const isAuthResolved =
    authState != null && authState.isPending !== true;
  const isAuthenticated = Boolean(authState?.isAuthenticated);

  return { oktaAuth, authState, isAuthResolved, isAuthenticated };
}
